__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "dashboard-webapp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/animations", "12.2.17-angular-12.3.9", () => (() => (__webpack_require__(/*! ./node_modules/@angular/animations/__ivy_ngcc__/fesm2015/animations.js */ 77294))), 1);
			register("@angular/common/http", "12.2.17-angular-12.3.9", () => (() => (__webpack_require__(/*! ./node_modules/@angular/common/__ivy_ngcc__/fesm2015/http.js */ 66683))), 1);
			register("@angular/common", "12.2.17-angular-12.3.9", () => (() => (__webpack_require__(/*! ./node_modules/@angular/common/__ivy_ngcc__/fesm2015/common.js */ 63262))), 1);
			register("@angular/compiler", "12.2.17-angular-12.3.9", () => (() => (__webpack_require__(/*! ./node_modules/@angular/compiler/fesm2015/compiler.js */ 6161))), 1);
			register("@angular/core", "12.2.17-angular-12.3.9", () => (() => (__webpack_require__(/*! ./node_modules/@angular/core/__ivy_ngcc__/fesm2015/core.js */ 63626))), 1);
			register("@angular/platform-browser-dynamic", "12.2.17-angular-12.3.9", () => (() => (__webpack_require__(/*! ./node_modules/@angular/platform-browser-dynamic/__ivy_ngcc__/fesm2015/platform-browser-dynamic.js */ 56408))), 1);
			register("@angular/platform-browser", "12.2.17-angular-12.3.9", () => (() => (__webpack_require__(/*! ./node_modules/@angular/platform-browser/__ivy_ngcc__/fesm2015/platform-browser.js */ 22680))), 1);
			register("@angular/router", "12.2.17-angular-12.3.9", () => (() => (__webpack_require__(/*! ./node_modules/@angular/router/__ivy_ngcc__/fesm2015/router.js */ 98190))), 1);
			register("@lst/lst-auth", "2.1.0", () => (() => (__webpack_require__(/*! ./node_modules/@savvaslearning/lst-auth/fesm2015/savvaslearning-lst-auth.js */ 59804))), 1);
			register("@ngrx/effects", "12.5.1", () => (() => (__webpack_require__(/*! ./node_modules/@ngrx/effects/__ivy_ngcc__/fesm2015/ngrx-effects.js */ 52991))), 1);
			register("@ngrx/store", "12.5.1", () => (() => (__webpack_require__(/*! ./node_modules/@ngrx/store/__ivy_ngcc__/fesm2015/ngrx-store.js */ 13521))), 1);
			register("@ngx-translate/core", "13.0.0", () => (__webpack_require__.e("node_modules_ngx-translate_core___ivy_ngcc___fesm2015_ngx-translate-core_js").then(() => (() => (__webpack_require__(/*! ./node_modules/@ngx-translate/core/__ivy_ngcc__/fesm2015/ngx-translate-core.js */ 85991))))));
			register("@ngx-translate/http-loader", "6.0.0", () => (__webpack_require__.e("node_modules_ngx-translate_http-loader___ivy_ngcc___fesm2015_ngx-translate-http-loader_js").then(() => (() => (__webpack_require__(/*! ./node_modules/@ngx-translate/http-loader/__ivy_ngcc__/fesm2015/ngx-translate-http-loader.js */ 49039))))));
			register("@savvaslearning/lst-ui-core", "1.1.3", () => (() => (__webpack_require__(/*! ./node_modules/@savvaslearning/lst-ui-core/fesm2015/savvaslearning-lst-ui-core.js */ 20220))), 1);
			register("apollo-angular", "1.10.0", () => (() => (__webpack_require__(/*! ./node_modules/apollo-angular/__ivy_ngcc__/fesm2015/ngApollo.js */ 15377))), 1);
			register("rxjs/operators", "6.6.7", () => (() => (__webpack_require__(/*! ./node_modules/rxjs/_esm2015/operators/index.js */ 51568))), 1);
			register("rxjs", "6.6.7", () => (() => (__webpack_require__(/*! ./node_modules/rxjs/_esm2015/index.js */ 68274))), 1);
			initExternal(34141);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};